<template>
  <div class="detail-view">
    <section class="section section--booking-engine">
      <booking-engine @search="() => { this.$router.push({ name: 'results' }) }"/>
    </section>
    <b-container>
      <section class="section section--loader" v-if="searching">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-else>
        <detail-content-block :property="property" />
      </section>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { sum, number, format } from 'mathjs'
import { service_handler } from '@src/services'
import { custom_event } from '@utilities'
import DetailContentBlock from '@liveeps/components/views/content-blocks/detail.vue'

export default {
  name: 'detail-view',

  components: {
    'detail-content-block': DetailContentBlock
  },

  props: {
  },

  data() {
    return {
      property: {},
    }
  },

  computed: {
    ...mapState({
      // stato globale
      searching: state => state.searching,
      occupancy: state => state.occupancy,
      availability: state => state.availability,

      // stato del modulo liveeps
      checkin: state => state.liveeps.checkin,
      checkout: state => state.liveeps.checkout,
      selected_property: state => state.liveeps.selected_property,
    }),

  },

  created() {
  },

  mounted() {
    this.price()
  },

  methods: {

    price() {
      let params = {
        checkin: this.checkin,
        checkout: this.checkout,
        occupancy: this.occupancy,
        property_id: this.selected_property.property_id,
      }

      this.$store.commit('searching', true)

      service_handler(
        'details',
        params
      ).then(
        (success) => {
          this.property  = success.data.data.property
          this.$store.commit('liveeps/update_selected_solution', {
            occupancy: this.occupancy,
            dates: { checkin: this.checkin, checkout: this.checkout }
          })
          this.$store.commit('searching', false)

          custom_event({
            event: 'view_item',
            ecommerce: {
              currency: "EUR",
              items: this.parseGa4EcommerceItems(this.property),
              value: this.parseGa4EcommerceItems(this.property).reduce((smy, item) => sum(smy, item.price), 0),
            }
          });
        },
      )
    },

    parseGa4EcommerceItems(property){
      const items = [],
            hotel_name = property.name

      property.rooms.forEach(room => {
        room.rates.forEach(rate => {
          items.push({
            item_id: room.id + "-" + rate.id,
            item_name: hotel_name + " - " + room.name,
            price: format(number(rate.pricing.total), {notation: 'fixed', precision: 2}),
          })
        })
      })

      return items
    },
  },
}
</script>

<style lang="scss" scoped>

  .section {

    &--booking-engine {
      margin: 0;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 50%;
        left: 0;
        right: 0;
        background-color: var(--extra1); // same as header
      }
    }
  }

</style>